module.exports = __webpack_public_path__ + "images/future-proof-bg-billing.webp";